import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import "../styles/InformesPendientes.css";

// Normalizar API_URL (remover barra final si existe)
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

const InformesDevueltos = () => {
  const [informes, setInformes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInformes = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/informes/devueltos`, {
          headers: getAuthHeaders()
        });
        setInformes(data);
      } catch (error) {
        console.error("❌ Error al obtener informes devueltos:", error);
      }
    };
    fetchInformes();
  }, []);

  const editarInforme = (informe) => {
    // Navegar al formulario principal pasando el informe en el state
    navigate('/home/informes', { 
      state: { informeToEdit: informe } 
    });
  };

  return (
    <div className="informes-container">
      <Navbar />
      <h2 className="title">Informes a Corregir</h2>
      <p className="text-muted mb-4" style={{ textAlign: 'center' }}>Informes que requieren correcciones antes de ser reenviados</p>

      <div className="table-wrapper">
        <table className="informes-table">
          <thead>
            <tr>
              <th>N° Informe</th>
              <th>Motivo</th>
              <th>Fecha</th>
              <th>Observación</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {informes.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                  No hay informes para corregir
                </td>
              </tr>
            ) : (
              informes.map((inf) => (
                <tr key={inf.id} className="row-hover">
                  <td>{inf.NroInforme}</td>
                  <td>{inf.Motivo}</td>
                  <td>{inf.FechaRealizado.split("T")[0]}</td>
                  <td style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {inf.Observacion || '-'}
                  </td>
                  <td className="acciones">
                    <button
                      className="icon-btn editar"
                      onClick={() => editarInforme(inf)}
                      title="Editar informe devuelto"
                    >
                      ✏️ Editar
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InformesDevueltos;
